import { queryOptions } from '@tanstack/react-query';
import type { ServiceCategoryDto } from '@upme/contracts';
import { api } from '../../app/api-client';

export const serviceCategoriesKey = ['admin', 'service-categories'] as const;

export const listServiceCategoriesOptions = () =>
  queryOptions({
    queryKey: [...serviceCategoriesKey],
    queryFn: () => api.get('admin/service-categories').json<ServiceCategoryDto[]>(),
    staleTime: 30_000,
  });

export const serviceCategoryByIdOptions = (id: string) =>
  queryOptions({
    queryKey: [...serviceCategoriesKey, id],
    queryFn: () => api.get(`admin/service-categories/${id}`).json<ServiceCategoryDto>(),
  });
